import { API_KEY } from "./constants/constants"

export const originals=`/discover/tv?api_key=${API_KEY}&with_networks=213`

export const action=`/discover/movie?api_key=${API_KEY}&with_genres=28`

export const comedy=`/discover/movie?api_key=${API_KEY}&with_genres=35`

export const horror=`/discover/movie?api_key=${API_KEY}&with_genres=27`

export const romance=`/discover/movie?api_key=${API_KEY}&with_genres=10749`

export const documentaries=`/discover/movie?api_key=${API_KEY}&with_genres=99`

export const ytId='https://api.themoviedb.org/3/movie/379686/videos?language=en-US&api_key=fe7618a98c8eaed5bf4a020ddb974602'